import { PRODUCT_SPECS } from "@/data/productSpecs";

const SpecTable = ({ rows }) => (
  <div className="rounded-xl overflow-hidden border border-black/10">
    <table className="w-full border-collapse">
      <tbody>
        {rows.map(([label, value], i) => (
          <tr key={label}>
            <td
              className={`bg-[#F2F2F0] text-[14px] font-semibold text-black/70 px-4 py-3 w-2/5 align-top ${
                i < rows.length - 1 ? "border-b border-black/10" : ""
              }`}
            >
              {label}
            </td>
            <td
              className={`bg-white text-[14px] font-normal text-black px-4 py-3 ${
                i < rows.length - 1 ? "border-b border-black/10" : ""
              }`}
            >
              {value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const ProductSpecs = ({ productId }) => {
  const data = PRODUCT_SPECS[productId];
  if (!data) return null;

  const half = Math.ceil(data.specs.length / 2);
  const columns = [data.specs.slice(0, half), data.specs.slice(half)];

  return (
    <section data-testid="product-specs" className="mt-16">
      <h2 className="font-display text-3xl sm:text-4xl uppercase font-semibold tracking-tight text-[#111418] mb-5">
        Características del producto
      </h2>
      <p className="text-black/70 text-base leading-relaxed max-w-3xl mb-5">{data.resumen}</p>
      <p className="text-xs font-semibold text-black/40 mb-2">Ideal para</p>
      <div className="flex flex-wrap gap-2 mb-8">
        {data.ideal.map((item) => (
          <span
            key={item}
            className="text-xs font-medium text-black/70 bg-white border border-black/10 rounded-full px-3 py-1.5"
          >
            {item}
          </span>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 items-start">
        {columns.map((col, i) => (
          <SpecTable key={i} rows={col} />
        ))}
      </div>
    </section>
  );
};
